/* The KPI row. Sized to sit inside the same 1124px content column the
   Availability tables use, so the two pages line up at the left edge and at
   the right. Tiles wrap rather than scroll: a KPI you have to scroll to is a
   KPI nobody reads. */
.strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(158px, 1fr));
  gap: 12px;
  width: var(--table-w);
  max-width: 100%;
}

.tile {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 14px 16px 13px;
  border: 1px solid var(--border-cell);
  border-radius: 10px;
  background: #fff;
}

/* One or two tiles per page carry the number the page is actually about. */
.emphasis {
  border-color: #d5e6fc;
  background: var(--bg-pill);
}

.label {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-muted);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 14px;
}

.valueRow {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.value {
  color: var(--text-title);
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* A loading tile draws the frame at the value's height, so nothing reflows
   when the number lands. */
.skeleton {
  display: inline-block;
  width: 78px;
  height: 20px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f2f4f7 25%, #e9edf3 37%, #f2f4f7 63%);
  background-size: 400% 100%;
  animation: shimmer 1.3s ease-in-out infinite;
}

@keyframes shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

.delta {
  flex: none;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--text-muted);
}
.up { color: var(--delta-up); }
.down { color: var(--delta-down); }

.foot {
  color: var(--text-muted);
  font-size: 11px;
  line-height: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* An "unavailable" foot is not the same as a quiet caption — it is the page
   explaining a dash, and it should read as prose rather than as a stat. */
.footMuted {
  font-style: italic;
  white-space: normal;
}
